import EditForm from './EditForm.js';

export default EditForm;